import { useState } from "react"
import { Button, Collapse, Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import { useGetPlacementsQuery } from "../../services/publications/placementsApi"
import { TemplateQueryFeedback } from "../templates/templateQueryFeedback"

export function PublicationImpact({
  publicationId,
}: {
  publicationId: string
}) {
  return <Impact key={publicationId} publicationId={publicationId} />
}
function Impact({ publicationId }: { publicationId: string }) {
  const [page, setPage] = useState(1)
  const [open, setOpen] = useState(false)
  const query = useGetPlacementsQuery({ publicationId, page, limit: 50 })
  const data = !query.error ? query.currentData : undefined
  return (
    <Stack
      spacing={1}
      component="section"
      aria-label="Область действия публикации"
    >
      <Typography variant="caption" color="text.secondary">
        Изменения применятся к следующим отправкам.
      </Typography>
      {!!data?.total && (
        <Button
          size="small"
          aria-expanded={open}
          sx={{ alignSelf: "flex-start" }}
          onClick={() => setOpen(!open)}
        >
          Размещений: {data.total}
        </Button>
      )}
      <TemplateQueryFeedback query={query} />
      <Collapse in={open && !!data?.total} unmountOnExit>
        <Stack spacing={1} sx={{ maxHeight: 240, overflow: "auto" }}>
          {data?.data.map((placement) => (
            <Button
              key={placement.id}
              component={Link}
              to={`/telegram/post-bot/placements/${encodeURIComponent(placement.id)}`}
            >
              Размещение {placement.id} — канал {placement.channelId}
            </Button>
          ))}
        </Stack>
        {(data?.totalPages ?? page) > 1 && (
          <Stack direction="row">
            <Button
              disabled={page <= 1 || query.isFetching}
              onClick={() => setPage(page - 1)}
            >
              Предыдущие размещения
            </Button>
            <Button
              disabled={!data || page >= data.totalPages || query.isFetching}
              onClick={() => setPage(page + 1)}
            >
              Следующие размещения
            </Button>
          </Stack>
        )}
      </Collapse>
    </Stack>
  )
}
